module.exports = __webpack_public_path__ + "static/media/logo-nso.88496267.jpg";